<template>
	<FormButton
		button-text="Search All"
		button-width="w-32"
		variant="custom"
		:button-classes="buttonClasses"
		@click="openModal(id)"
	>
		<div class="flex items-center space-x-2 w-full justify-center">
			<MagnifyingGlassIcon
				class="w-5 h-5 text-mx-gray-400 dark:text-mx-gray-300"
				aria-hidden="true"
			/>
			<span>
				Search All
			</span>
		</div>
	</FormButton>
</template>

<script setup lang="ts">
import { MagnifyingGlassIcon } from '@heroicons/vue/20/solid'
import { useModal } from '@/composables/useModal'
import { useMagicKeys, whenever } from '@vueuse/core'

const { openModal } = useModal()
const keys = useMagicKeys()

const props = defineProps({
	id: {
		type: String,
		required: true
	},
	buttonClasses: {
		type: String,
		default: 'text-mx-gray-500 dark:text-mx-gray-300 dark:bg-mx-green-700 hover:bg-mx-gray-200 dark:hover:bg-mx-green-600'
	}
})

const { id } = toRefs(props)

whenever(keys.ctrl_shift_x, () => {
	openModal(id.value)
})
</script>
